module.exports = __webpack_public_path__ + "static/circularstd-black-40935c7fb92dc3b00a9d478b042a5318.woff";